<template>
  <div>
    <v-dialog
      v-model="show"
      max-width="80vh"
      scrollable
    >
      <v-card>
        <v-card-title>
          Deferment Types
          <v-spacer></v-spacer>
          <v-text-field
            v-model="search"
            append-icon="mdi-magnify"
            label="Search"
            single-line
            hide-details
            dense
            class="mr-4"
          ></v-text-field>
          <v-btn
            icon
            @click="show = false"
          >
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text class="py-3">
          <v-data-table
            dense
            fixed-header
            height="45vh"
            :headers="tableHeaders"
            :items="defermentTypes"
            :search="search"
            :items-per-page="10"
            :footer-props="{
              'items-per-page-options': [10, 20, 50, -1]
            }"
          >
            <template v-slot:[`item.Postponement_Name`]="{ item }">
              <v-text-field
                dense
                hide-details="auto"
                :rules="[rules.required, rules.alreadyExist]"
                v-if="editMode && currentItem && currentItem.Type_of_Postponement_ID === item.Type_of_Postponement_ID"
                v-model="currentItem.Postponement_Name"
              ></v-text-field>
              <span v-else>{{ item.Postponement_Name }}</span>
            </template>
            <template v-slot:[`item.Actions`]="{ item }">
              <v-btn
                :disabled="editMode && (currentItem.Type_of_Postponement_ID !== item.Type_of_Postponement_ID) || (currentItem && currentItem.Type_of_Postponement_ID === item.Type_of_Postponement_ID && canUpdate)"
                :color="editMode && currentItem && currentItem.Type_of_Postponement_ID === item.Type_of_Postponement_ID ? 'success' : 'primary'"
                small
                icon
                @click="onEditClick(item)"
              >
                <v-icon>
                  {{ editMode && currentItem && currentItem.Type_of_Postponement_ID === item.Type_of_Postponement_ID ? 'mdi-check-circle' : 'mdi-pencil-circle' }}
                </v-icon>
              </v-btn>
              <v-btn
                small
                icon
                color="red darken-2"
                v-if="!editMode || (currentItem && currentItem.Type_of_Postponement_ID !== item.Type_of_Postponement_ID)"
                :disabled="editMode"
                @click="onDeleteClick(item)"
              >
                <v-icon>mdi-delete-circle</v-icon>
              </v-btn>
              <v-btn
                v-if="editMode && currentItem && currentItem.Type_of_Postponement_ID === item.Type_of_Postponement_ID"
                color="primary"
                small
                icon
                @click="onCancelClick"
              >
                <v-icon>mdi-close-circle</v-icon>
              </v-btn>
            </template>
          </v-data-table>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="success"
            small
            :disabled="editMode"
            @click="createNewTypeDialog = !createNewTypeDialog"
          >
            Create New
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog
      max-width="500"
      v-model="createNewTypeDialog"
    >
      <v-card>
        <v-card-title>
          New Deferment Type
          <v-spacer></v-spacer>
          <v-btn
            icon
            @click="createNewTypeDialog = false"
          >
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text class="pa-4">
          <v-text-field
            v-model="newTypeName"
            label="Deferment Name"
            autofocus
            :rules="[rules.required, rules.alreadyExist]"
          ></v-text-field>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            small
            color="primary"
            :disabled="canSave"
            @click="createNewDefermentType"
          >
            Save
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <ConfirmOrDeniedDialog
      v-if="deleteTypeDialog"
      v-model="deleteTypeDialog"
      :mode="confirmOrDeniedDialogModes.delete"
      @onDeleteClick="deleteDefermentType"
      @onCancelClick="cancelDelete"
    />
  </div>
</template>

<script>
import { getApiErrorMessage } from '@/utils/apiError'
export default {
  name: 'DefermentTypeManager',
  components: {
    ConfirmOrDeniedDialog: () => import('@/components/global/ConfirmOrDeniedDialog.vue')
  },
  props: {
    value: {
      required: false,
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      search: '',
      currentItem: null,
      createNewTypeDialog: false,
      defermentTypes: [],
      deleteTypeDialog: false,
      editMode: false,
      newTypeName: '',
      tableHeaders: [
        {
          text: 'Deferment Name',
          value: 'Postponement_Name',
          divider: true,
          class: 'px-2 text-no-wrap',
          cellClass: 'px-2 text-no-wrap'
        },
        {
          text: '#',
          value: 'Actions',
          align: 'center',
          cellClass: 'px-2 text-no-wrap',
          class: 'px-2 text-no-wrap',
          width: 100,
          sortable: false
        }
      ],
      rules: {
        required: v => !!v || 'Required',
        alreadyExist: (val) => this.validateOnAlreadyExist(val) || 'The deferment name already exists'
      }
    }
  },
  mounted () {
    this.getDefermentTypes()
  },
  computed: {
    user () {
      return this.$store.getters.getUser
    },
    show: {
      get () {
        return this.value
      },
      set (value) {
        this.$emit('input', value)
      }
    },
    canUpdate () {
      if (!this.currentItem || !this.currentItem.Postponement_Name) return true
      return !this.currentItem.Postponement_Name?.trim().length || !this.validateOnAlreadyExist(this.currentItem.Postponement_Name, this.currentItem.Type_of_Postponement_ID)
    },
    canSave () {
      return !this.newTypeName || !this.newTypeName?.trim().length || !this.validateOnAlreadyExist(this.newTypeName)
    },
    confirmOrDeniedDialogModes () {
      return this.$store.getters.getConfirmOrDeniedDialogModes
    }
  },
  methods: {
    validateOnAlreadyExist (val, id = null) {
      if (!val) return true
      return !this.defermentTypes.some(el =>
        el.Postponement_Name.toLowerCase() === val.trim().toLowerCase() && el.Type_of_Postponement_ID !== id
      )
    },
    onEditClick (item) {
      if (this.editMode) {
        this.updateDefermentType()
      } else {
        this.tableHeaders[0].sortable = false
        this.currentItem = Object.assign({}, item)
        this.editMode = true
      }
    },
    onCancelClick () {
      this.editMode = false
      this.currentItem = null
      this.tableHeaders[0].sortable = true
    },
    onDeleteClick (item) {
      this.deleteTypeDialog = true
      this.currentItem = Object.assign({}, item)
    },
    cancelDelete () {
      this.deleteTypeDialog = false
      this.currentItem = null
    },
    getDefermentTypes () {
      this.axios.get('/api/deferment_types', {
        headers: {
          Authorization: 'Bearer ' + this.user.token
        }
      }).then(res => {
        this.defermentTypes = res.data
      }).catch(error => {
        const errorMsg = getApiErrorMessage(error)
        this.$store.dispatch('setError', { errorMsg })
      })
    },
    createNewDefermentType () {
      this.axios.post('/api/deferment_type', {
        Postponement_Name: this.newTypeName.trim()
      }, {
        headers: {
          Authorization: 'Bearer ' + this.user.token
        }
      }).then(res => {
        this.createNewTypeDialog = false
        this.newTypeName = ''
        this.getDefermentTypes()
        this.$store.dispatch('setSuccess', { successMsg: 'New deferment type successfully created' })
      }).catch(error => {
        const errorMsg = getApiErrorMessage(error)
        this.$store.dispatch('setError', { errorMsg })
      })
    },
    updateDefermentType () {
      this.axios.put(`/api/deferment_type/${this.currentItem.Type_of_Postponement_ID}`, {
        Postponement_Name: this.currentItem.Postponement_Name.trim()
      }, {
        headers: {
          Authorization: 'Bearer ' + this.user.token
        }
      }).then(res => {
        this.getDefermentTypes()
        this.onCancelClick()
        this.$store.dispatch('setSuccess', { successMsg: 'Deferment type successfully updated' })
      }).catch(error => {
        const errorMsg = getApiErrorMessage(error)
        this.$store.dispatch('setError', { errorMsg })
      })
    },
    deleteDefermentType () {
      this.axios.delete(`/api/deferment_type/${this.currentItem.Type_of_Postponement_ID}`, {
        headers: {
          Authorization: 'Bearer ' + this.user.token
        }
      }).then(res => {
        this.getDefermentTypes()
        this.cancelDelete()
        this.$store.dispatch('setSuccess', { successMsg: 'Deferment type successfully deleted' })
      }).catch(error => {
        const errorMsg = getApiErrorMessage(error)

        if (errorMsg.includes('conflicted with the REFERENCE constraint')) {
          this.$store.dispatch('setError', { errorMsg: 'Cannot delete type because it is used in another module.' })
        } else {
          this.$store.dispatch('setError', { errorMsg })
        }
      })
    }
  }
}
</script>
